import { render, staticRenderFns } from "./BannerGrid.vue?vue&type=template&id=042c44cc"
import script from "./BannerGrid.vue?vue&type=script&lang=js"
export * from "./BannerGrid.vue?vue&type=script&lang=js"
import style0 from "./BannerGrid.vue?vue&type=style&index=0&id=042c44cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports